export default [
  {
    path: '/project/:project_id',
    name: 'project',
    component: () => import('@/pages'),
    redirect: '/project/:project_id/workflow/workflowList',
    meta: { title: '工程中心', icon: 'project', redirect: '/projects' },
    children: [
      {
        path: 'workflow',
        name: 'workflow',
        component: () => import('@/pages'),
        meta: { title: '流程管理', icon: 'pie-chart', parent: 'project' },
        children: [
          {
            path: 'workflowList',
            name: 'workflowList',
            component: () => import('@/pages/project/workflow'),
            meta: { title: '流程列表', icon: 'pie-chart', parent: 'workflow' }
          },
          {
            path: 'workflowDetail',
            name: 'workflowDetail',
            component: () => import('@/pages/project/workflow/detail'),
            meta: { title: '流程详情', icon: 'pie-chart', parent: 'workflow', show: false }
          },
          {
            path: 'workflowCreate',
            name: 'workflowCreate',
            component: () => import('@/pages/project/workflow/create'),
            meta: { title: '创建流程', icon: 'pie-chart', parent: 'workflow', show: false }
          },
          {
            path: 'releaseList',
            name: 'releaseList',
            component: () => import('@/pages/project/workflow/release'),
            meta: { title: '发布评审', icon: 'pie-chart', parent: 'workflow' }
          },
          {
            path: 'releaseCreate',
            name: 'releaseCreate',
            component: () => import('@/pages/project/workflow/release/edit'),
            meta: { title: '创建发布评审', icon: 'pie-chart', parent: 'workflow', show: false }
          },
          {
            path: 'releaseEdit',
            name: 'releaseEdit',
            component: () => import('@/pages/project/workflow/release/edit'),
            meta: { title: '编辑发布评审', icon: 'pie-chart', parent: 'workflow', show: false }
          },
          {
            path: 'releaseDetail',
            name: 'releaseDetail',
            component: () => import('@/pages/project/workflow/release/detail'),
            meta: { title: '发布评审详情', icon: 'pie-chart', parent: 'workflow', show: false }
          }
        ]
      },
      {
        path: 'cicd',
        name: 'cicd',
        component: () => import('@/pages'),
        meta: { title: 'CI/CD', icon: 'rocket', parent: 'project' },
        children: [
          {
            path: 'pipeline',
            name: 'pipeline',
            component: () => import('@/pages/project/pipeline'),
            meta: { title: '持续集成', icon: 'pie-chart', parent: 'cicd' },
            children: []
          },
          {
            path: 'detail',
            name: 'pipelineDetail',
            component: () => import('@/pages/project/pipeline/detail'),
            meta: { title: '构建详情', icon: 'pie-chart', parent: 'cicd', show: false },
            children: []
          }
        ]
      },
      {
        path: 'versionList',
        name: 'versionList',
        component: () => import('@/pages/project/version'),
        meta: { title: '迭代管理', icon: 'profile', parent: 'project' },
        children: []
      },
      {
        path: 'storyList',
        name: 'storyList',
        component: () => import('@/pages/project/story'),
        meta: { title: '需求管理', icon: 'snippets', parent: 'project' },
        children: []
      },
      {
        path: 'task',
        name: 'task',
        component: () => import('@/pages/project/task'),
        meta: { title: '任务管理', icon: 'schedule', parent: 'project' },
        children: []
      },
      {
        path: 'service',
        name: 'projectService',
        component: () => import('@/pages/project/service'),
        meta: { title: '服务管理', icon: 'pie-chart', parent: 'project' },
        children: []
      },
      {
        path: 'qualityManage',
        name: 'qualityManage',
        component: () => import('@/pages/dashboard'),
        meta: { title: '质量管理', icon: 'pie-chart', parent: 'project' },
        children: [
          {
            path: 'caseReview',
            name: 'caseReview',
            component: () => import('@/pages/dashboard'),
            meta: { title: '测试概览', icon: 'pie-chart', parent: 'qualityManage' }
          },
          {
            path: 'testCase',
            name: 'testCase',
            component: () => import('@/pages/dashboard'),
            meta: { title: '测试用例', icon: 'pie-chart', parent: 'qualityManage' }
          },
          {
            path: 'testPlan.js',
            name: 'testPlan.js',
            component: () => import('@/pages/dashboard'),
            meta: { title: '测试计划', icon: 'pie-chart', parent: 'qualityManage' }
          },
          {
            path: 'testReport',
            name: 'testReport',
            component: () => import('@/pages/dashboard'),
            meta: { title: '用例报告', icon: 'pie-chart', parent: 'qualityManage' }
          }
        ]
      }
    ]
  }
];
